/** Reserves a fixed multi-line label height so values align across the card grid. */
export const HISTORY_CARD_LABEL_CLASS = "leading-[14px] min-h-[28px]";
